import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { CommandPalette } from "@/components/CommandPalette";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { VoicePlaybackProvider } from "@/lib/audio/VoicePlaybackProvider";
import { isFullPageRoute } from "@/lib/layout/fullPageRoutes";
import { AppBaseLayout } from "./_app/-components/AppBaseLayout";

export const Route = createFileRoute("/_auth/app/_app")({
	beforeLoad: ({ context }) => {
		if (!context.get_token()) {
			throw new Error("Not authenticated");
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();

	// A full-page route draws its own chrome: no app header, no chat widget, no
	// command palette competing with the one question it is asking.
	if (isFullPageRoute(location.pathname)) {
		return <Outlet />;
	}

	return (
		<AppBaseLayout>
			{/* One controller app-wide — playback survives route changes (§4). */}
			<VoicePlaybackProvider>
				<CommandPalette />
				<Outlet />
				<ChatWidget />
			</VoicePlaybackProvider>
		</AppBaseLayout>
	);
}
